// import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import { changeSkin } from '@/utils/common.js';
import Payment from '@/components/payment/payment.vue';
import ProjectService from '../../project.service';
import updateBankMixins from '@/utils/mixins/update-bank-mixins.js';
import ApplyRevocation from '@/components/apply-revocation/index.vue';
export default {
  mixins: [updateBankMixins],
  components: {
    Pagination,
    Payment,
    ApplyRevocation
  },
  data() {
    return {
      currentProjectId: '',
      signApproveStatus: [],
      total: 0,
      tableList: [],
      date: [],
      searchForm: {
        projectName: '',
        signStatus: '', // 报名状态
        pageNum: 1,
        pageSize: 5,
        bidName: '' // 标的名称
      },
      showPayment: false,
      actionId: '',
      applyReparams: {
        dialogVisible: false,
        bidId: '',
        phone: ''
      }
    };
  },
  created() {
    let params = {
      dictId: 'SIGN_APPROVE_STATUS',
      excludeList: ['51', '52', '54', '53', '55', '60', '61', '62', '63', '70', '80']
    };
    ProjectService.selectDictListByExcludeDictId(params).then(res => {
      if (res && res.code === '0') {
        this.signApproveStatus = [{code: '', value: '全部'}, ...res.data];
      }
    });
    this.getSignUpProjectList();
  },
  methods: {
    // 申请撤销
    applyRevocation (item) {
      this.applyReparams = {
        dialogVisible: true,
        bidId: item.bidId,
        phone: item.technicalDirectorPhone
      };
    },
    // 撤销报名
    revocationSignUp (item) {
      this.$confirm('您将撤销报名信息，是否重新报名?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        distinguishCancelAndClose: true,
        type: 'warning',
        beforeClose: (action, instance, done) => {
          console.log(action);
          console.dir(instance);
          if (action !== 'close') {
            ProjectService.revocationSignUp(item.bidId).then(({ code }) => {
              if (code === '0') {
                // 选择是 则跳转到报名页面
                if (action === 'confirm') {
                  this.$router.push({ path: '/transaction-pro/signup', query: {
                    id: item.projectId,
                    bidSignRelationId: item.bidSignRelationId
                  }});
                } else {
                  this.$successMessage('已撤销报名，您还可以重新报名');
                  this.getSignUpProjectList();
                }
              }
            }).catch((error) => {
              if (error && error.data && error.data.reason) {
                this.$errorMessage(error.data.reason);
              } else {
                this.$errorMessage('撤销失败');
              }
            });
          }
          done();
        }
      });
    },
    changeSkin,
    indexMethod(index) {
      // console.log(this.searchForm);
      return (Number(this.searchForm.pageNum) - 1) * Number(this.searchForm.pageSize) + index + 1;
    },
    // 获取我的报名采购标的列表
    getSignUpProjectList(page){
      console.log(page);
      if (page) {
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      } else {
        this.searchForm.pageNum = 1;
        this.searchForm.pageSize = 5;
      }
      let query = {};
      Object.keys(this.searchForm).forEach(key => {
        if (this.searchForm[key]) {
          query[key] = this.searchForm[key];
        }
      });
      ProjectService.getSignUpProjectList(query).then(res => {
        if (res && res.code === '0') {
          this.total = res.data.total;
          this.tableList = res.data.list;
        }
      });
    },
    onChangeDate (event) {
      this.searchForm.startTime = event && event[0];
      this.searchForm.endTime = event && event[1];
    },
    clear () {
      this.searchForm = {
        projectName: '',
        signStatus: '', // 报名状态
        pageNum: 1,
        pageSize: 5,
        bidName: '' // 标的名称
      };
      this.date = [];
      this.getSignUpProjectList();
    },
    toPaymentPage (item) {
      this.$router.push('/person-center/project/sign-up-project/margin-payment?id=' + item.bidId + '&bidSignRelationId=' + item.bidSignRelationId);
    },
    displayStatus(status) {
      const target = this.signApproveStatus.find(item => Number(item.code) === status);
      return (target && target.value) || '';
    },
    goToSignUpDetail (item) {
      this.$router.push('/person-center/project/sign-up-project/detail?id=' + item.bidSignRelationId);
    }
  }
};
